// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "css/app" + "." + __webpack_require__.h().slice(0, 6) + ".css";
};